import React from 'react';

import Img from '../Img';

import styles from './slide.scss';

const Slide = props => {
    const slideClass = `slide${props.number}`;
    return (
        <div className={styles.slideWrapper}>
            <div className={styles[slideClass]}>
                <div className={styles.popUp}>
                    <div className={styles.hoverImgBackground}>
                        <Img
                            className={styles.hoverImg}
                            src={`/img/curve/mobile/${props.number}.png`}
                            srcSet={`/img/curve/mobile/${props.number}@2x.png 2x, /img/curve/mobile/${props.number}@3x.png 3x`}
                        />
                    </div>
                    {!props.noCurve && (
                        <div className={styles.curve}>
                            <Img src={`/img/curve/mobile/curve${props.number}.svg`} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Slide;
